var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocx = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#C6E1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6211 28.6237C36.6211 33.2892 36.6211 35.6219 35.201 37.0713C33.7809 38.5206 31.4953 38.5206 26.9241 38.5206H22.0756C17.5044 38.5206 15.2188 38.5206 13.7988 37.0713C12.3787 35.6219 12.3787 33.2892 12.3787 28.6237V20.3763C12.3787 15.7109 12.3787 13.3781 13.7988 11.9288C15.2188 10.4794 17.5044 10.4794 22.0756 10.4794H26.9241C31.4953 10.4794 33.7809 10.4794 35.201 11.9288C36.6211 13.3781 36.6211 15.7109 36.6211 20.3763V28.6237Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19H18",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24H18",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29H18",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/docx.4c397899232b87bfc6400f1036a79d09.svg";